export const transformValueToVH = (value: number): string => {
  return `${(value / window.innerHeight) * 100}vh`;
};
